// src/App.tsx
import React, { useState } from 'react';
import AudioMeter from '../../DecibelMeter/AudioMeter/AudioMeter';
import Visualizer from '../../DecibelMeter/Visualizer/Visualizer';
import Settings from '../../Settings/Settings';
import "./Home.css"

export function App(): JSX.Element {
  const [db, setDb] = useState<number>(0);
  const [refreshRate, setRefreshRate] = useState<number>(500);

  return (
    <div className="App">
      <h1>Welcome to the Decibel Meter App!</h1>
      <p>Use the navigation to explore the app and measure sound levels around you.</p>
      <div>
        <div className='db' id="db">{db} dB</div>
        Current Decibel Level
      </div>
      <AudioMeter onDbChange={setDb} />
      <Visualizer decibels={db} />
      <Settings refreshRate={refreshRate} onRefreshRateChange={setRefreshRate} />
    </div>
  );
}

export default App;
